import React from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
const uuidv4 = require('uuid/v4');

export const createBarGraph = (issuesArr, meta, skill, isEditMode) => {
  let g_data = {};
  let xaxis_field_value = null;
  let xaxis_field = null;
  let noValue = [];

  let field = meta.x_axis;
  // console.log(field);
  let appearanceData = meta.appearanceData;
  let fieldData = null;
  if (meta && meta.x_axis_type) fieldData = meta.x_axis_type;
  let xaxis_field_path = field;
  let fieldObjPath = meta.x_axis.split('.').splice(0, 2).join('.');
  let xaxis_path = fieldObjPath;
  let fieldObj = {};
  const getValueKey = (obj, keys) => {
    for (const key in obj) {
      if (keys.includes(key)) {
        return key;
      }
    }
    return null;
  };
  issuesArr.forEach((item) => {
    // console.log(item.fields);
    try {
      xaxis_field_value = eval('item.' + xaxis_field_path);
      xaxis_field = eval('item.' + xaxis_path);
      // console.log('my data', xaxis_field);
      //for custom report
      // const key = xaxis_field_path.split('.')[1]
      // if(fieldData && fieldData.type === 'array'){
      //   xaxis_field_value = xaxis_field_value
      // }
    } catch (e) {
      xaxis_field_value = null;
    }
    if (xaxis_field_value) {
      //for custom report
      fieldObj[xaxis_field_value] = xaxis_field;
      // console.log('xaxis_field_value', xaxis_field_value, fieldData);
      const validTypes = [
        'project',
        'group',
        'option-with-child',
        'sd-servicelevelagreement',
        'timetracking',
      ];
      if (
        fieldData &&
        (fieldData.type === 'array' || fieldData.type === 'sd-approvals')
      ) {
        const key = xaxis_field_path.split('.')[1];
        xaxis_field_value.forEach((data) => {
          const value =
            key === 'labels'
              ? data
              : key === 'customfield_10021'
              ? 'Flagged'
              : typeof data === 'string'
              ? data
              : data.name || data.displayName || data.value || data.filename;
          if (g_data[value]) {
            g_data[value]++;
          } else {
            g_data[value] = 1;
          }
          fieldObj[value] = data;
        });
      } else if (fieldData && fieldData.type === 'datetime') {
        fieldObj[xaxis_field_value] = xaxis_field;
        if (g_data[xaxis_field_value.split('T')[0]]) {
          g_data[xaxis_field_value.split('T')[0]]++;
        } else {
          g_data[xaxis_field_value.split('T')[0]] = 1;
        }
      } else if (fieldData && fieldData.type === 'resolution') {
        fieldObj[xaxis_field_value] = xaxis_field;
        if (g_data[xaxis_field_value.name]) {
          g_data[xaxis_field_value.name]++;
        } else {
          g_data[xaxis_field_value.name] = 1;
        }
      } else if (fieldData && validTypes.includes(fieldData.type)) {
        const mainKeys = ['name', 'displayName', 'value'];
        const key = getValueKey(xaxis_field, mainKeys);
        fieldObj[xaxis_field_value[key] || fieldData.name] =
          xaxis_field[key] || fieldData.name;
        if (g_data[xaxis_field_value[key] || fieldData.name]) {
          g_data[xaxis_field_value[key] || fieldData.name]++;
        } else {
          g_data[xaxis_field_value[key] || fieldData.name] = 1;
        }
      }
      //normal logic before custom fields
      else {
        if (
          typeof xaxis_field_value === 'object' &&
          Object.keys(xaxis_field_value).length > 0
        ) {
          fieldObj[fieldData.name] = fieldData.name;
          if (g_data[fieldData.name]) {
            g_data[fieldData.name]++;
          } else {
            g_data[fieldData.name] = 1;
          }
        } else {
          fieldObj[xaxis_field_value] = xaxis_field;
          if (g_data[xaxis_field_value]) {
            g_data[xaxis_field_value]++;
          } else {
            g_data[xaxis_field_value] = 1;
          }
        }
      }
    } else {
      noValue.push(item);
      // console.log('coming here \n');
      if (xaxis_field_path && xaxis_field_path.split('.')[1] == 'assignee') {
        fieldObj['Unassigned'] = { id: 'unassigned', key: 'unassigned' };
        if (g_data['Unassigned']) {
          g_data['Unassigned']++;
        } else {
          g_data['Unassigned'] = 1;
        }
      }
    }
  });

  for (const key in g_data) {
    if (key.length > 50) {
      const trimmedKey = key.slice(0, 50) + '...';
      g_data[trimmedKey] = g_data[key];
      delete g_data[key];
    }
  }

  let g_series_data_keys = Object.keys(g_data).reverse();
  // console.log(g_series_data_keys);
  // console.log(g_data);
  // let g_series_data_values = Object.values(g_data).reverse()

  const getID = (key) => {
    if (xaxis_path.includes('reporter') || xaxis_path.includes('assignee')) {
      return (
        (fieldObj[key] && fieldObj[key].accountId) ||
        (fieldObj[key] && fieldObj[key].key)
      );
    }
    return (fieldObj[key] && fieldObj[key].id) || uuidv4();
  };
  let g_series_data_values = [];
  g_series_data_keys.forEach((key) => {
    let name = key;
    g_series_data_values.push({
      name: name,
      y: g_data[key],
      id: getID(key),
    });
  });

  if (isEditMode && appearanceData && appearanceData.length > 0) {
    g_series_data_values = appearanceData;
  }

  // console.log(fieldObj);
  // console.log(g_series_data_keys);
  let dataArray = [
    {
      data: g_series_data_values,
    },
  ];

  let modifiedDataArray;
  // if (appearanceData) {
  //   modifiedDataArray = dataArray[0].data
  //     .map((item) => {
  //       let modifiedData =
  //         Array.isArray(appearanceData) &&
  //         appearanceData.find((data) => data.id == item.id);
  //       if (modifiedData) {
  //         if (modifiedData.color) {
  //           item.color = modifiedData.color;
  //         }
  //         if (modifiedData.isHidden) {
  //           item.isHidden = modifiedData.isHidden;
  //         }
  //         if (modifiedData.updatedName) {
  //           item.name = modifiedData.updatedName
  //             ? modifiedData.updatedName
  //             : item.name;
  //         }
  //         item.position = modifiedData.position;
  //         // item = modifiedData;
  //       }
  //       return item;
  //     })
  //     .filter((data) => data)
  //     .sort((a, b) => a.position - b.position)
  //     .filter((item) => !item.isHidden);

  //   dataArray = [{ data: modifiedDataArray }];
  // }

  let x_axis_info = {
    categories: modifiedDataArray && modifiedDataArray.map((item) => item.name),
  };

  let chartData = {
    // width: 300,
    // hieght: 200,
    // innerHeight: 200,
    // outerHeight: 250,
  };
  chartData.title = meta && meta.report_name;

  // let meta=skill.cardInformation.cardInformation
  //   if (projName) {
  //     chartData.subtitle = {
  //       text: ` ${Utils.truncateString(projName, 16)}`,
  //       style: {
  //         color: '#ccc',
  //       },
  //     }
  //   }
  // if (!meta.report_theme) {

  // } else {
  //   chartData.theme = meta.report_theme;
  // }

  let yAxis = {
    gridLineWidth: 0,
    lineWidth: 0,
    lineColor: 'transparent',
    minorGridLineWidth: 0,
    minorTickLength: 0,
    tickLength: 0,
  };
  chartData.yAxis = yAxis;

  let report_type;
  if (
    skill &&
    skill.cardInformation &&
    skill.cardInformation.key === 'custom_report_2'
  ) {
    x_axis_info.title = {
      text: fieldData && fieldData.name,
    };
  }

  const x_axis_name =
    (meta && meta.x_axis_type && meta.x_axis_type.name) ||
    (meta && meta['x-axis-type'] && meta['x-axis-type'].name);

  const y_axis_name =
    skill &&
    skill.cardInformation &&
    skill.cardInformation.key &&
    skill.cardInformation.key == 'custom_report_2'
      ? meta && meta.y_axis_type && meta.y_axis_type.name
      : 'Issue Count';

  // report_type = 'column';

  if (meta && meta.report_type) report_type = meta.report_type;

  let url = null;

  // url = makeAnyGraph(
  //   skill,
  //   report_type,
  //   meta.report_name,
  //   x_axis_info,
  //   y_axis_name,
  //   dataArray,
  //   false,
  //   false,
  //   false,
  //   chartData
  // );
  let noDataerr = false;
  return {
    report_type,
    g_data,
    noValue,
    xaxis_field_value,
    chartData,
    x_axis_info,
    dataArray,
    y_axis_name,
    x_axis_name,
  };
};

export const createCustomChart = ({
  skill,
  issueArr,
  meta,
  x_axis_field,
  y_axis_field,
}) => {
  let fieldData = null;
  let y_fieldData = null;
  let xaxis_field = null;

  if (meta.x_axis_type) fieldData = meta.x_axis_type;
  //if (meta.y_axis_type) y_fieldData = meta.y_axis_type;
  if (meta.number_field_type) y_fieldData = meta.number_field_type;
  // let data = await getJiraIssues(skill, "", field, 20);
  let dataObj = {};
  let issueCount = {};
  let avgArray = [];

  let fieldObjPath = meta.x_axis.split('.').splice(0, 2).join('.');
  let xaxis_path = fieldObjPath;
  let fieldObj = {};
  issueArr.forEach((item) => {
    let xaxis_field_value = '';
    let yaxis_field_value = '';
    // console.log('comminghere');
    try {
      xaxis_field_value = eval('item.' + x_axis_field);
      xaxis_field = eval('item.' + xaxis_path);
      // console.log(x_axis_field,xaxis_path,xaxis_field,xaxis_field_value)
    } catch (e) {
      xaxis_field_value = null;
      // console.info("xaxis  field value not found",e);
    }
    try {
      // y_axis_field = issues.fields.customfield

      yaxis_field_value = eval('item.' + y_axis_field);
      // console.log(y_axis_field,yaxis_field_value)
    } catch (e) {
      yaxis_field_value = null;
    }
    if (xaxis_field_value) {
      fieldObj[xaxis_field_value] = xaxis_field;
      // console.log(xaxis_field_value, yaxis_field_value);
      // to handle arays
      if (fieldData && fieldData.type === 'array') {
        xaxis_field_value.forEach((data) => {
          const key = x_axis_field.split('.')[1];
          const value =
            key === 'labels'
              ? data
              : key === 'customfield_10021'
              ? 'Flagged'
              : data.name;
          if (dataObj[value]) {
            if (yaxis_field_value) {
              dataObj[value] += yaxis_field_value;
            }
          } else {
            dataObj[value] = yaxis_field_value;
          }
        });
      } else if (fieldData && fieldData.type === 'datetime') {
        if (dataObj[xaxis_field_value.split('T')[0]]) {
          if (yaxis_field_value) {
            dataObj[xaxis_field_value.split('T')[0]] += yaxis_field_value;
          }
        } else {
          dataObj[xaxis_field_value.split('T')[0]] = yaxis_field_value;
        }
      } else if (fieldData && fieldData.type === 'resolution') {
        if (dataObj[xaxis_field_value.name]) {
          dataObj[xaxis_field_value.name]++;
        } else {
          dataObj[xaxis_field_value.name] = 1;
        }
      } else {
        if (dataObj[xaxis_field_value]) {
          if (yaxis_field_value && meta.y_axis_type.value === 'Sum') {
            dataObj[xaxis_field_value] += yaxis_field_value;
          } else if (
            yaxis_field_value &&
            meta.y_axis_type.value === 'Average'
          ) {
            dataObj[xaxis_field_value] += yaxis_field_value;
            avgArray.push({ x: xaxis_field_value, y: yaxis_field_value });
          }
        } else {
          dataObj[xaxis_field_value] = yaxis_field_value;
          avgArray.push({ x: xaxis_field_value, y: yaxis_field_value });
        }
      }
    } else {
      if (yaxis_field_value) {
        if (dataObj.None) {
          dataObj.None += yaxis_field_value;
        } else {
          dataObj.None = yaxis_field_value;
        }
        // if (dataObj.None) {
        //   dataObj.None += yaxis_field_value;
        // } else {
        //   dataObj.None = yaxis_field_value;
        // }
      }
    }
  });

  let values = [];
  if (avgArray) {
    avgArray.map((item) => values.push(Object.values(item)));
    values.map((item) =>
      issueCount[item[0]]
        ? (issueCount[item[0]] += 1)
        : (issueCount[item[0]] = 1)
    );
  }
  let keys = Object.keys(dataObj);

  let arr = [];
  if (
    y_fieldData &&
    (y_fieldData.value.split('.')[2] === 'aggregatetimeoriginalestimate' ||
      y_fieldData.value.split('.')[2] === 'timeestimate' ||
      y_fieldData.value.split('.')[2] === 'timespent' ||
      y_fieldData.value.split('.')[2] === 'timeoriginalestimate' ||
      y_fieldData.value.split('.')[2] === 'aggregatetimeestimate' ||
      y_fieldData.value.split('.')[2] === 'aggregatetimespent') &&
    meta.y_axis_type.value === 'Sum'
  ) {
    keys.forEach((key) => {
      let hrs = Number((dataObj[key] / 3600).toFixed(2));
      arr.push({ name: key, y: hrs, id: fieldObj[key] && fieldObj[key].id });
    });
  } else if (
    y_fieldData &&
    (y_fieldData.value.split('.')[2] === 'aggregatetimeoriginalestimate' ||
      y_fieldData.value.split('.')[2] === 'timeestimate' ||
      y_fieldData.value.split('.')[2] === 'timespent' ||
      y_fieldData.value.split('.')[2] === 'timeoriginalestimate' ||
      y_fieldData.value.split('.')[2] === 'aggregatetimeestimate' ||
      y_fieldData.value.split('.')[2] === 'aggregatetimespent') &&
    meta.y_axis_type.value === 'Average'
  ) {
    keys.forEach((key) => {
      let hrs = Number((dataObj[key] / 3600).toFixed(2));
      arr.push({
        name: key,
        y: hrs / issueCount[key],
        id: fieldObj[key] && fieldObj[key].id,
      });
      //console.log(arr)
    });
  } else if (y_fieldData && meta.y_axis_type.value === 'Average') {
    keys.forEach((key) => {
      let name = key;
      arr.push({
        name: name,
        y: dataObj[key] / issueCount[key],
        id: fieldObj[key] && fieldObj[key].id,
      });
    });
  } else {
    keys.forEach((key) => {
      let name = key;

      arr.push({
        name: name,
        y: dataObj[key],
        id: fieldObj[key] && fieldObj[key].id,
      });
    });
  }

  let dataArray = [
    {
      data: arr,
    },
  ];
  if (
    fieldData &&
    fieldData.value.split('.')[2] === 'issuetype' &&
    y_fieldData &&
    y_fieldData.value.split('.')[2] === 'customfield_10024'
  ) {
    // <<<<<<<<<< in case of "issue type" and "story points" removing issue types other than "story" >>>>>>>>>>>>
    dataArray[0].data = [
      dataArray[0].data.find((data) => data.name === 'Story'),
    ];
  }

  //to handle "Unassigned"
  // dataArray[0].data = dataArray[0].data.map(data => {
  //   if(data.name === 'None') {
  //     return {name : 'Unassigned' ,y:data.y}}
  //   else return data
  // })

  const x_axis_info = {
    title: {
      text: meta.x_axis_type && meta.x_axis_type.name,
    },
    categories: keys,
  };

  let yAxis = {
    gridLineWidth: 0,
    lineWidth: 0,
    lineColor: 'transparent',
    minorGridLineWidth: 0,
    minorTickLength: 0,
    tickLength: 0,
  };

  const x_axis_name =
    (meta && meta.x_axis_type && meta.x_axis_type.name) ||
    (meta && meta['x-axis-type'] && meta['x-axis-type'].name);

  let y_axis_name =
    meta.y_axis_type &&
    meta.y_axis_type.name &&
    meta.y_axis_type.name == 'Issue Count'
      ? meta.y_axis_type.name
      : meta.number_field_type && meta.number_field_type.name;
  if (y_fieldData && y_fieldData.value.split('.')[2] !== 'customfield_10024') {
    // <<<<< adding "hrs" for y axis title, except for "story points"
    y_axis_name += ' (hrs)';
  }

  let projName = meta.projectInfo && meta.projectInfo.name;

  let chartData = {
    // subtitle: {
    //   text: ` ${truncateString(projName, 16)}`,
    //   // style: {
    //   //   color: '#ccc'
    //   // }
    // },
  };
  chartData.theme = meta.report_theme;
  chartData.yAxis = yAxis;

  let report_type = 'column';

  if (meta.report_type) report_type = meta.report_type;

  let url = null;
  let noDataerr = false;

  return {
    report_type,
    // g_data,
    noValue: noDataerr,
    // xaxis_field_value,
    chartData,
    x_axis_info,
    dataArray,
    y_axis_name,
    x_axis_name,
  };
};

const getIssueCountBurndown = (data) => {
  let keys = Object.keys(data.changes);

  let intialValue = 0;

  let issueKeys = {};
  let competedArr = {};
  let rejectTedEvent = [];
  let arr = [];

  // console.log(intialValue)

  let count = 0;

  let intialValueIndex = 0;

  keys.forEach((key, index) => {
    if (key <= data.startTime) {
      if (data.changes[key].length > 0) {
        //  i=data.changes[key].length-1
        intialValueIndex += data.changes[key].length;
      }
    }
    data.changes[key].forEach((item) => {
      if (item.added && item.column && item.column.done == false) {
        if (
          !issueKeys[item.key] ||
          (issueKeys[item.key] && competedArr[item.key])
        ) {
          count += 1;
        }

        issueKeys[item.key] = true;
        delete competedArr[item.key];
      } else if (item.added && item.column && item.column.done) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          //  intialValue-=1
          count -= 1;
        }
        issueKeys[item.key] = true;
        competedArr[item.key] = true;
      } else if (item.column && item.column.done == false) {
        if (issueKeys[item.key] && competedArr[item.key]) {
          count += 1;
        }
        delete competedArr[item.key];
      } else if (item.added) {
        if (!issueKeys[item.key] && !competedArr[item.key]) {
          count += 1;
        }
        issueKeys[item.key] = true;
      } else if (item.added == false && item.column && item.column.done) {
        if (issueKeys[item.key]) {
          count -= 1;
        }
        delete issueKeys[item.key];
        competedArr[item.key] = true;
      } else if (
        item.added == false &&
        item.column &&
        item.column.done == false
      ) {
        // console.log("item.added==false",item.key)
        // console.log(issueKeys[item.key],competedArr[item.key])
        if (issueKeys[item.key]) {
          count -= 1;
        }
        delete issueKeys[item.key];
        delete competedArr[item.key];
      } else if (item.column && item.column.done) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          count -= 1;
        }
        competedArr[item.key] = true;
      } else if (item.added == false) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          count -= 1;
        }

        delete issueKeys[item.key];
      } else {
        rejectTedEvent.push(item);
      }

      arr.push([parseInt(key), count, item.key]);
    });
  });

  return {
    dataArray: arr,
    intialValueIndex: intialValueIndex,
    finalValue: count,
  };
};

const getRemainingEstimateArray = (data) => {
  let keys = Object.keys(data.changes);

  let issueKeys = {};
  let competedArr = {};
  let estimateTime = {};
  let rejectTedEvent = [];
  let arr = [];

  let values = {};
  let count = 0;
  // let competedArr=[]
  let intialValueIndex = 0;
  keys.forEach((key, index) => {
    if (key < data.startTime) {
      if (data.changes[key].length > 0) {
        //  i=data.changes[key].length-1
        intialValueIndex += data.changes[key].length;
      }
    }
    //  intialValueIndex+=data.changes[key].length

    data.changes[key].forEach((item) => {
      if (item.added) {
        if (!issueKeys[item.key]) {
          values = addRemainingEstimtae(item, count, estimateTime);
        }
        issueKeys[item.key] = true;
        delete competedArr[item.key];
        if (item.column && item.column.done) {
          competedArr[item.key] = true;
        } else if (item.column && item.column.done == false) {
          delete competedArr[item.key];
        }
      } else if (item.added == false) {
        if (issueKeys[item.key]) {
          values = removeRemainingTimeEstimate(item, count, estimateTime);
          delete issueKeys[item.key];
        }
        if (item.column && item.column.done) {
          competedArr[item.key] = true;
        } else if (item.column && item.column.done == false) {
          delete competedArr[item.key];
        }
      } else if (item.timeC && item.timeC.newEstimate) {
        if (issueKeys[item.key]) {
          values = addRemainingEstimtae(item, count, estimateTime);
        } else {
          estimateTime[item.key] = item.timeC.newEstimate;
        }
      } else if (item.timeC && item.timeC.oldEstimate) {
        if (issueKeys[item.key]) {
          values = removeRemainingTimeEstimate(item, count, estimateTime);
        } else {
          delete estimateTime[item.key];
        }
      } else {
        rejectTedEvent.push(item);
      }

      if (values) {
        count = values.count >= 0 ? values.count : count;
        estimateTime = values.estimateTime ? values.estimateTime : estimateTime;
      }

      arr.push([parseInt(key), count, item.key]);
    });
  });

  return {
    dataArray: arr,
    intialValueIndex: intialValueIndex,
    finalValue: count,
  };
};

const addRemainingEstimtae = (item, count, estimateTime) => {
  if (item.timeC && item.timeC.newEstimate) {
    if (item.timeC.oldEstimate) {
      let diff = item.timeC.oldEstimate - item.timeC.newEstimate;
      count = (count * 3600 - diff) / 3600;
    } else {
      count += item.timeC.newEstimate / 3600;
    }
    estimateTime[item.key] = item.timeC.newEstimate;
  } else {
    if (estimateTime[item.key]) {
      count += estimateTime[item.key] / 3600;
    }
  }

  return { count: count, estimateTime: estimateTime };
};

const removeRemainingTimeEstimate = (item, count, estimateTime) => {
  if (item.timeC && item.timeC.newEstimate) {
    if (item.timeC.oldEstimate) {
      let diff = item.timeC.oldEstimate;
      count = (count * 3600 - diff) / 3600;
    } else {
      count -= item.timeC.newEstimate / 3600;
    }
    estimateTime[item.key] = item.timeC.newEstimate;
  } else if (item.timeC && item.timeC.oldEstimate) {
    let diff = item.timeC.oldEstimate;
    count = (count * 3600 - diff) / 3600;

    delete estimateTime[item.key];
  } else {
    if (estimateTime[item.key]) {
      count -= estimateTime[item.key] / 3600;
      // count-=storyPoint[item.key]
    }
  }
  return { count: count, estimateTime: estimateTime };
};

////////
export const velocityGraphJira = (skill, jiraData) => {
  try {
    // console.log("velocityGraphJira\n\n")
    let meta = skill;
    let projName = '',
      velocity_estimation = 'story_points';

    if (meta.velocity_estimation)
      velocity_estimation = meta.velocity_estimation;

    // console.log("calling getValidJiraSkill\n\n")
    // let jiraSkill = await Jira.getValidJiraSkill(skill.workspace_id);

    // console.log("calling velocityReport\n\n")
    let promiseArray = [
      // JiraApiMiddleware.velocityReport(jiraSkill, meta.boardId),
    ];

    if (!meta.board || !meta.board.location) {
      // promiseArray.push(
      //   JiraApiMiddleware.getJiraBoardProjects(jiraSkill, meta.boardId)
      // );
    } else {
      projName = meta.board.location.projectName;
    }

    // let infoData = await Promise.all(promiseArray);

    // let data = infoData[0]
    let data = jiraData.velocityReport;

    if (velocity_estimation === 'original_time_estimate') {
      //to convert it too hours
      Object.keys(data && data.velocityStatEntries).map((id) => {
        const d = data.velocityStatEntries[id];
        d.estimated.value =
          d.estimated.value != 0 ? d.estimated.value / 3600 : 0;
        d.estimated.value = parseFloat(d.estimated.value.toFixed(1));
        d.completed.value =
          d.completed.value != 0 ? d.completed.value / 3600 : 0;
        d.completed.value = parseFloat(d.completed.value.toFixed(1));

        data.velocityStatEntries[id] = d;
      });
    }

    // to hide the two 0 values
    Object.keys(data && data.velocityStatEntries).map((id) => {
      const d = data.velocityStatEntries[id];
      if (d.estimated.value === 0 && d.completed.value === 0) {
        d.estimated.value = '';
        d.completed.value = '';
      }
      data.velocityStatEntries[id] = d;
    });
    // console.log("ENTRIES : ",data.velocityStatEntries);

    if (!meta.board || !meta.board.location) {
      let projectData = jiraData.velocityReport.sprint;
      if (projectData.values[0]) {
        projName = projectData.values[0].name;
      } else {
        throw 'No project for board';
      }
    }

    // <<< theme >>>
    let defaultTheme = false;
    if (meta.report_theme === 'default' || meta.report_theme === 'dark')
      defaultTheme = true;
    let y_axis_label = 'Story Points';
    if (velocity_estimation === 'original_time_estimate')
      y_axis_label = 'Original Time Estimate (in hrs)';
    else if (velocity_estimation === 'issue_count')
      y_axis_label = 'Issue Count';

    let url = getVelocityGraphUrl(
      skill,
      data,
      projName,
      defaultTheme,
      y_axis_label
    );
    return url;
  } catch (err) {
    // console.error(
    //   err,
    //   JSON.stringify({
    //     workspace_id: skill.workspace_id,
    //     user_id: skill.user_id,
    //   })
    // );

    return err;
  }
};
const getVelocityGraphUrl = (
  skill,
  data,
  projName,
  defaultTheme,
  y_axis_label
) => {
  let meta = skill;
  try {
    let estimated = {
      name: 'Commitment',
      data: [],
    };
    let completed = {
      name: 'Completed',
      data: [],
    };

    let x_axis_array = [];

    data.sprints
      .sort((a, b) => a.sequence - b.sequence)
      .forEach((sprint) => {
        // data.sprints.forEach(sprint=>{
        x_axis_array.push(sprint.name);
        estimated.data.push(
          data.velocityStatEntries[sprint.id].estimated.value
        );
        completed.data.push(
          data.velocityStatEntries[sprint.id].completed.value
        );
      });

    let dataArray = [estimated, completed];

    let x_axis_info = {
      categories: x_axis_array,
    };
    // let _obj={name:name}

    let chartData = {};
    chartData.legend = {
      itemStyle: {
        /*"color": "#ccc",*/ fontWeight: 'normal',
        fontSize: 6,
        marginTop: 0,
      },
      padding: 0,
    };

    if (projName) {
      chartData.subtitle = {
        text: ` ${projName}`,
        style: {
          color: '#ccc',
        },
      };
    }

    const yAxis = {
      gridLineWidth: 0,
      lineWidth: 1,
      lineColor: 'transparent',
      minorGridLineWidth: 0,
      minorTickLength: 0,
      tickLength: 0,
    };
    chartData.yAxis = yAxis;

    // let url=await makeAnyGraph(_obj,"column",null,x_axis_info,"Story Points",dataArray,false,true,false,chartData)
    let url = makeAnyGraph(
      skill,
      'column',
      null,
      x_axis_info,
      y_axis_label,
      dataArray,
      false,
      true,
      false,
      chartData
    );
    return url;
  } catch (err) {
    throw err;
  }
};

const getTimeEstimateArray = (data) => {
  let keys = Object.keys(data.changes);

  let issueKeys = {};
  let competedArr = {};
  let estimateTime = {};
  let rejectTedEvent = [];
  let arr = [];

  let values = {};
  let count = 0;
  // let competedArr=[]
  let intialValueIndex = 0;
  keys.forEach((key, index) => {
    if (key < data.startTime) {
      if (data.changes[key].length > 0) {
        //  i=data.changes[key].length-1
        intialValueIndex += data.changes[key].length;
      }
    }
    //  intialValueIndex+=data.changes[key].length

    data.changes[key].forEach((item) => {
      if (item.added && item.column && item.column.done == false) {
        if (
          !issueKeys[item.key] ||
          (issueKeys[item.key] && competedArr[item.key])
        ) {
          values = addEstimtae(item, count, estimateTime);
        }
        issueKeys[item.key] = true;
        delete competedArr[item.key];
      } else if (item.added && item.column && item.column.done) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeEstimate(item, count, estimateTime);
        }
        issueKeys[item.key] = true;
        competedArr[item.key] = true;
      } else if (item.column && item.column.done == false) {
        if (issueKeys[item.key] && competedArr[item.key]) {
          values = addEstimtae(item, count, estimateTime);
        }
        delete competedArr[item.key];
      } else if (item.added) {
        if (!issueKeys[item.key] && !competedArr[item.key]) {
          values = addEstimtae(item, count, estimateTime);
        }
        issueKeys[item.key] = true;
      } else if (item.added == false && item.column && item.column.done) {
        if (issueKeys[item.key]) {
          values = removeEstimate(item, count, estimateTime);
        }
        delete issueKeys[item.key];
        competedArr[item.key] = true;
      } else if (
        item.added == false &&
        item.column &&
        item.column.done == false
      ) {
        if (issueKeys[item.key]) {
          values = removeEstimate(item, count, estimateTime);
        }
        delete issueKeys[item.key];
        delete competedArr[item.key];
      } else if (item.column && item.column.done) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeEstimate(item, count, estimateTime);
        }
        competedArr[item.key] = true;
      } else if (item.added == false) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeEstimate(item, count, estimateTime);
        }

        delete issueKeys[item.key];
        // competedArr[item.key]=true
      } else if (item.statC && item.statC.newValue) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = addEstimtae(item, count, estimateTime);
        } else {
          estimateTime[item.key] = item.statC.newValue;
        }
      } else if (item.statC && item.statC.oldValue) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeEstimate(item, count, estimateTime);
        } else {
          delete estimateTime[item.key];
        }
      } else {
        rejectTedEvent.push(item);
      }

      if (values) {
        count = values.count >= 0 ? values.count : count;
        estimateTime = values.estimateTime ? values.estimateTime : estimateTime;
      }

      arr.push([parseInt(key), count, item.key]);
    });
  });

  return {
    dataArray: arr,
    intialValueIndex: intialValueIndex,
    finalValue: count,
  };
};

const addEstimtae = (item, count, estimateTime) => {
  if (item.statC && item.statC.newValue) {
    if (item.statC.oldValue) {
      let diff = item.statC.oldValue - item.statC.newValue;
      count = (count * 3600 - diff) / 3600;
    } else {
      count += item.statC.newValue / 3600;
    }
    estimateTime[item.key] = item.statC.newValue;
  } else {
    if (estimateTime[item.key]) {
      count += estimateTime[item.key] / 3600;
    }
  }

  return { count: count, estimateTime: estimateTime };
};

const removeEstimate = (item, count, estimateTime) => {
  if (item.statC && item.statC.newValue) {
    if (item.statC.oldValue) {
      let diff = item.statC.oldValue;
      count = (count * 3600 - diff) / 3600;
    } else {
      count -= item.statC.newValue / 3600;
    }
    estimateTime[item.key] = item.statC.newValue;
  } else if (item.statC && item.statC.oldValue) {
    let diff = item.statC.oldValue;
    count = (count * 3600 - diff) / 3600;

    delete estimateTime[item.key];
  } else {
    if (estimateTime[item.key]) {
      count -= estimateTime[item.key] / 3600;
      // count-=storyPoint[item.key]
    }
  }
  return { count: count, estimateTime: estimateTime };
};

const getStortyPointArray = (data) => {
  let keys = Object.keys(data.changes);

  let issueKeys = {};
  let competedArr = {};
  let storyPoint = {};
  let rejectTedEvent = [];
  let arr = [];

  let values = {};
  let count = 0;
  // let competedArr=[]
  let intialValueIndex = 0;
  keys.forEach((key, index) => {
    if (key < data.startTime) {
      if (data.changes[key].length > 0) {
        //  i=data.changes[key].length-1
        intialValueIndex += data.changes[key].length;
      }
    }
    data.changes[key].forEach((item) => {
      if (item.added && item.column && item.column.done == false) {
        if (
          !issueKeys[item.key] ||
          (issueKeys[item.key] && competedArr[item.key])
        ) {
          values = addStoryPoints(item, count, storyPoint);
        }
        issueKeys[item.key] = true;
        delete competedArr[item.key];
      } else if (item.added && item.column && item.column.done) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeStoryPoints(item, count, storyPoint);
        }
        issueKeys[item.key] = true;
        competedArr[item.key] = true;
      } else if (item.column && item.column.done == false) {
        if (issueKeys[item.key] && competedArr[item.key]) {
          values = addStoryPoints(item, count, storyPoint);
        }
        delete competedArr[item.key];
      } else if (item.added) {
        if (!issueKeys[item.key] && !competedArr[item.key]) {
          values = addStoryPoints(item, count, storyPoint);
        }
        issueKeys[item.key] = true;
      } else if (item.added == false && item.column && item.column.done) {
        if (issueKeys[item.key]) {
          values = removeStoryPoints(item, count, storyPoint);
        }
        delete issueKeys[item.key];
        competedArr[item.key] = true;
      } else if (
        item.added == false &&
        item.column &&
        item.column.done == false
      ) {
        //   console.log("item.added==false",item.key)
        // console.log(issueKeys[item.key],competedArr[item.key])
        if (issueKeys[item.key]) {
          values = removeStoryPoints(item, count, storyPoint);
        }
        delete issueKeys[item.key];
        delete competedArr[item.key];
      } else if (item.column && item.column.done) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          // console.log(item.key)
          values = removeStoryPoints(item, count, storyPoint);

          if (item.key == 'TP-1307') {
            // console.log(item.key)
            //  console.log("After",values)
          }
        }
        competedArr[item.key] = true;
      } else if (item.added == false) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeStoryPoints(item, count, storyPoint);
        }

        delete issueKeys[item.key];
        // competedArr[item.key]=true
      } else if (item.statC && item.statC.newValue) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = addStoryPoints(item, count, storyPoint);
        } else {
          storyPoint[item.key] = item.statC.newValue;
        }
      } else if (item.statC && item.statC.oldValue) {
        if (issueKeys[item.key] && !competedArr[item.key]) {
          values = removeStoryPoints(item, count, storyPoint);
        } else {
          delete storyPoint[item.key];
        }
      } else {
        rejectTedEvent.push(item);
      }

      if (values) {
        // if(item.key=="TP-1307"){
        // //   // console.log(item.key)
        // //  console.log("After hehehhehehhe",count,values.count)
        // // }
        count = values.count >= 0 ? values.count : count;
        storyPoint = values.storyPoint ? values.storyPoint : storyPoint;
      }
      // if(item.key=="TP-1307"){
      //   // console.log(item.key)
      //  console.log("After bfjhwebfjbwejfbwejbfjehwbfjhwebfjhewbfjhbewjhbfjhewbfjhwebjh",count)
      // }
      arr.push([parseInt(key), count, item.key]);
    });
  });
  //  console.log(competedArr)
  //  console.log(issueKeys)
  //  issueKeys[item.key]
  return {
    dataArray: arr,
    intialValueIndex: intialValueIndex,
    finalValue: count,
  };
};
const addStoryPoints = (item, count, storyPoint) => {
  if (item.statC && item.statC.newValue) {
    if (item.statC.oldValue) {
      let diff = item.statC.oldValue - item.statC.newValue;
      count = count - diff;
    } else {
      count += item.statC.newValue;
    }
    storyPoint[item.key] = item.statC.newValue;
  } else {
    if (storyPoint[item.key]) {
      count += storyPoint[item.key];
    }
  }

  return { item: item, count: count, storyPoint: storyPoint };
};

const removeStoryPoints = (item, count, storyPoint) => {
  if (item.statC && item.statC.newValue) {
    if (item.statC.oldValue) {
      let diff = item.statC.oldValue;
      count = count - diff;
    } else {
      count -= item.statC.newValue;
    }
    storyPoint[item.key] = item.statC.newValue;
  } else if (item.statC && item.statC.oldValue) {
    let diff = item.statC.oldValue;
    count = count - diff;

    delete storyPoint[item.key];
  } else {
    // console.log(item.key)
    // if(item.key=="TP-1307"){
    //   console.log(storyPoint["TP-1307"])
    // }

    if (storyPoint[item.key]) {
      count -= storyPoint[item.key];
    }
  }
  return { item: item, count: count, storyPoint: storyPoint };
};
export const burnDownChart = (skill, jiraData) => {
  try {
    let meta = skill;
    let projName = '';

    if (!meta.board || !meta.board.location) {
    } else {
      projName = meta.board.location.projectName;
    }
    let sprints = jiraData.sprints;
    if (!meta.board.location) {
      let projectData = jiraData.projData;
      if (projectData.values[0]) {
        projName = projectData.values[0].name;
      } else {
        throw 'No project for board';
      }
    }
    let currentSprint =
      sprints && sprints.find((sprint) => sprint.originBoardId == meta.boardId);

    if (currentSprint) {
      meta.sprintId = currentSprint.id;
    } else if (sprints && sprints.length > 0) {
      meta.sprintId = sprints[0].id;
      currentSprint = sprints[0];
    } else {
      throw 'No active sprint found';
    }
    let data = jiraData.burnDownReport;

    // console.log("currentSprint", JSON.stringify(currentSprint))
    //  console.log(JSON.stringify(data.changes))
    let arrData = {};

    let y_name = '';
    let lFormat = '';
    if (meta.field == 'issueCount_') {
      arrData = getIssueCountBurndown(data);
      y_name = 'Issue Count';
    } else if (meta.field == 'field_timeoriginalestimate') {
      y_name = 'Original Time Estimate in hrs';
      arrData = getTimeEstimateArray(data);
      lFormat = '{point.y:.2f}';
    } else if (meta.field == 'field_timeestimate') {
      y_name = 'Remaining Time Estimate in hrs';
      arrData = getRemainingEstimateArray(data);
      lFormat = '{point.y:.2f}';
    } else {
      y_name = 'Story Points';
      arrData = getStortyPointArray(data);
    }
    // console.log(arrData)
    let intialValueIndex = arrData.intialValueIndex;
    let arr = arrData.dataArray;
    // console.log(arr[intialValueIndex-1])
    let iIndex =
      intialValueIndex > 0 ? arr[intialValueIndex - 1] : intialValueIndex;
    // let sprintStartValue=arr[intialValueIndex][1]
    let sprintStartValue = [parseInt(data.startTime), iIndex[1]];
    let graphArr = arr.splice(intialValueIndex, arr.length - 1);
    graphArr.unshift(sprintStartValue);

    if (data.completeTime) {
      graphArr.push([data.completeTime, arrData.finalValue]);
    } else {
      graphArr.push([data.now, arrData.finalValue]);
    }

    //  console.log(JSON.stringify(graphArr))
    let x_axis_info = {
      type: 'datetime',
      min: data.startTime,
      max: data.completeTime
        ? data.completeTime > data.endTime
          ? data.completeTime
          : data.endTime
        : data.now > data.endTime
        ? data.now
        : data.endTime,
      dateTimeLabelFormats: {
        // don't display  year
        day: '%e %b',
      },
      // tickInterval: 604800*1000,
      tickInterval: 172800 * 1000,
      // title: {
      //     text: "Date"
      // },

      gridLineWidth: 0,
      lineWidth: 1,
      minorGridLineWidth: 0,
      minorTickLength: 0,
      tickLength: 0,
      padding: 1,

      // gridLineWidth: 1,
      gridLineColor: '#222',
      // lineColor: '#222',
    };
    let dataArray = [
      {
        name: 'Actual',
        color: 'rgba(100,252,227,0.85)',
        fontSize: 6,
        padding: 0,
        step: true,
        data: graphArr,
        marker: {
          symbol: 'circle',
          radius: 2,
        },
      },
      {
        name: 'Ideal',
        color: 'rgba(177,255,50,0.65)',
        fontSize: 6,
        padding: 0,
        lineWidth: 0.8,
        dashStyle: 'Dash',
        marker: {
          radius: 0,
        },
        dataLabels: {
          enabled: false,
        },
        data: [sprintStartValue, [data.endTime, 0]],
      },
    ];

    // console.log(JSON.stringify(dataArray))
    // console.log(x_axis_info)
    //  let labelValue={point.y:.2f}
    // ending ${moment(currentSprint.endDate).fromNow()}
    let chartData = {
      chart: {
        // backgroundColor: '#101010'
        // marginLeft: 20,
        // marginBottom: 20,

        spacingBottom: 25,
        spacingTop: 20,
        spacingLeft: 10,
        marginRight: 25,
        // Explicitly tell the width and height of a chart
        width: 350,
        height: 250,
        borderWidth: 4,
        borderRadius: 2,
        borderColor: {
          linearGradient: [0, 0, 0, 500, 500, 500],
          stops: [
            [0, 'rgba(255, 217, 192, 1)'],
            [1, 'rgba(253, 201, 240, 1)'],
            [2, 'rgba(209, 228, 255, 1)'],
          ],
        },
      },
      style: {
        fontFamily: 'Inter',
      },
      yAxis: {
        gridLineWidth: 0,
        lineWidth: 1,
        minorGridLineWidth: 0,
        labels: {
          style: {
            color: 'grey',
          },
        },
        title: {
          text: y_name,
          margin: 5,
        },
      },
      title: {
        text: `${currentSprint.name} Burndown `,
        style: {
          fontSize: '10px',
        },
        padding: 0,
      },
      subtitle: {
        text: ` ${projName}`,
        style: {
          // color: '#ccc'
          fontSize: 6,
        },
        padding: 0,
      },
      legend: {
        itemStyle: {
          /*"color": "#ccc",*/ fontWeight: 'normal',
          fontSize: 6,
          marginTop: 0,
        },
        padding: 0,
      },
      plotOptions: {
        line: {
          dataLabels: {
            style: {
              fontSize: '8px',
              fontWeight: 'normal',
              textOutline: '0px',
            },
            color: '#ccc',
            enabled: true,
          },
          label: {
            enabled: false,
          },
          color: '#fff',
          lineWidth: 2,
        },
        padding: 0,
      },
      exporting: {
        scale: 4,
      },
      currentSprint: currentSprint,
      series: dataArray,
      xAxis: x_axis_info,
    };

    return {
      skill,
      x_axis_info,
      y_title: y_name,
      dataArray,
      lFormat,
      chartData,
    };
    //   return url
  } catch (err) {
    // console.error(
    //   err,
    //   JSON.stringify({
    //     workspace_id: skill.workspace_id,
    //     cardskillid: skill._id,
    //   })
    // );
    throw err;
  }
};

export const makeAnyGraph = (
  skill,
  type,
  title,
  x_axis_info,
  y_title,
  data,
  stack,
  isLegend,
  labelFormat,
  chartData
) => {
  //   makeAnyGraph(skill,"column",null,x_axis_info,"Issue Count",dataArray,false,false,false,chartData)

  // console.log(JSON.stringify(data),x_axis_info,chartData)

  let chartDetails = {
    type: 'png',
    width: chartData && chartData.width ? chartData.width : 100,
    // height:800,
    options: {
      chart: {
        type: type,
      },
      xAxis: x_axis_info,
      yAxis: {
        title: {
          text: y_title,
          allowDecimals: false,
        },
      },
      title: {
        text: skill && skill.name,
      },

      plotOptions: {
        column: {
          stacking: stack,
        },
        series: {
          dataLabels: {
            enabled: true,
            format: labelFormat ? labelFormat : '{y}',
          },
        },
        pie: {
          dataLabels: {
            enabled: true,
            // format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            format:
              '<b>{point.name}</b>: {point.y:.1f} ({point.percentage:.0f}%)',
          },
        },
      },
      legend: {
        enabled: isLegend,
      },
      credits: {
        enabled: false,
      },
      series: data,
    },
  };

  if (chartData && chartData.resources) {
    chartDetails.resources = chartData.resources;
  }
  // if (chartData && chartData.theme) {
  //   if (chartData.theme == 'dark') {
  //     chartDetails.resources = {
  //       files: 'http://54.71.99.77/theme/dark-unica.js',
  //     };
  //   }
  // }
  if (chartData) {
    if (chartData.chart)
      chartDetails.options.chart = {
        ...chartData.chart,
        ...chartDetails.options.chart,
      };

    if (chartData.title) chartDetails.options.title = chartData.title;

    if (chartData.subtitle)
      chartDetails.options.subtitle = {
        ...chartData.subtitle,
        ...chartDetails.options.subtitle,
      };
    if (chartData.yAxis)
      chartDetails.options.yAxis = {
        ...chartData.yAxis,
        ...chartDetails.options.yAxis,
      };
    if (chartData.xAxis)
      chartDetails.options.xAxis = {
        ...chartData.xAxis,
        ...chartDetails.options.xAxis,
      };
    if (chartData.legend)
      chartDetails.options.legend = {
        ...chartData.legend,
        ...chartDetails.options.legend,
      };
    if (chartData.plotOptions)
      chartDetails.options.plotOptions = {
        ...chartData.plotOptions,
        ...chartDetails.options.plotOptions,
      };
    if (chartData.exporting)
      chartDetails.options.exporting = {
        ...chartData.exporting,
        ...chartDetails.options.exporting,
      };
  } else {
    chartDetails.resources = {
      files: 'http://54.71.99.77/theme/dark-unica.js',
    };
  }
  //console.log(postData(skill._id,skill.workspace_id,chartDetails),"testingpielog")
  return chartDetails;
  // sendGraph(skill,url)
};

// export const customChart = (skill, jiraData, key)=>{
//   const y_axis_type = skill.y_axis
//       if (y_axis_type === 'fields.issue_count') key = 'jira_count_graph'
//       else {
//         // let  {url,data} = await makeCustomReport({skill})
//         // sendGraph(skill,url,data.issues,data.jql)

//         let meta = skill
//         //console.log("\n\n\n\n data:\n\n\n",data);

//         let x_axis_field = meta.x_axis
//         //let y_axis_field = meta.y_axis;
//         let y_axis_field = meta.number_field.split('.')
//         y_axis_field.shift()
//         y_axis_field = y_axis_field.join('.')
//         let x_field = x_axis_field.split('.')[1]
//         //const y_field = y_axis_field.split(".")[1];
//         let y_field = y_axis_field.split('.')[1]
//         // console.log("\n\n\n\nx_field:",x_axis_field);

//         // console.log("\n\n\n\ny_field:",y_axis_field);

//         //const field = `${x_field},${y_field}`;
//         const field = `${x_field},${y_field}`
//         // console.log("\n\n\n\nfield:",field);
//         let data = jiraData
//         // console.log("\n\nrunning skill :",data.issues[0].fields)

//         if (data.totalIssues === 0) {
//           throw { err: 'no_issue', }
//         } else {
//           let { chartData, noDataerr } = makeCustomReport({
//             skill,
//             data,
//             meta,
//             x_axis_field,
//             y_axis_field,
//           })
//           if (noDataerr)
//             throw { err: 'no_issue', team, appSkill: data.appSkill }
//           else return chartData
//         }
//       }
// }
const truncateString = (data, truncateLength = 30) => {
  if (data.length > truncateLength)
    data = data.slice(0, truncateLength) + '...';
  return data;
};
